export default {
  $vuetify: {
    noDataText: 'No Country found',

    common: {
      giftcard: 'Purchase <br> Gift Card',
      coupons: 'Purchase <br> Coupons',
      deposit: 'Add to <br> Balance',
      close: 'Close',
      cancel: 'Cancel',
      back: 'Back',
      continue: 'Continue',
      confirm: 'Confirm',
      home: 'Home',
      details: 'Details',
      quantity: 'Quantity',
      other: 'Other',
      purchased: 'Purchased',
      expires: 'Expires',
      includingTax: '(inc. Tax)',
      logout: 'Logout',
      orMore: ' or more',
      submit: 'Submit',
      tryAgain: 'Try Again',
      success: 'Success',
      info: 'Info',
      edit: 'Edit',
      hours: 'Hours',
      closed: 'Closed',
      location: 'Location',
      contact: 'Contact',
      custom: 'Custom',
    },

    account: {
      cancel: 'Cancel',
      creditCard: 'Credit Card',
      nameOnCard: 'Name On Card',
      cardNumber: 'Card Number',
      expires: 'Expires',
      cvc: 'CVC',
      mmyy: 'MM / YY',
      country: 'Billing Country',
      saveCard: 'Save Card',
      addPaymentMethod: 'Add Payment Method',
      otherPostalCode: 'For non US or Canadian cards, please enter any number'
    },

    featureSelect: {
      title: 'Select one of the below features'
    },

    checkout: {
      title: 'Payment Information',
      pay: 'Pay',
      confirmDeposit: 'Confirm Deposit',
      confirmPurchase: 'Confirm Purchase',
      reviewYourCart: 'Review Your Cart',
      choosePaymentOption: 'Choose Payment Option',
      paymentInformation: 'Payment Information',
      receipt: 'Receipt',
      digitalEGiftCard: 'Digital E-Gift Card',
      subtotal: 'Subtotal',
      yourGiftCardDetails: 'Your Gift Card Details',
      to: 'To',
      from: 'From',
      selectPaymentMethod: 'Select Payment Method',
      bonus: 'Bonus',
      points: 'Points',
      depositDirectlyToAccount: 'Your deposit will be directly credited to the account associated with the provided phone number, resulting in an updated balance.',
      receiptEmailSameAsRecipientEmail: 'Receipt email is the same as Recipient\'s Email',
      personalizedMessage: 'Personalized Message',
      backToAllGiftDetails: 'Back to Gift Card details',
      depositDetails: 'Deposit Details',
      depositTo: 'Deposit to:',
      addPayment: 'Add Payment'
    },

    confirmation: {
      thankyou: 'Thank you for your order',
      thankyouWithName: 'Thank you for your order, {0}',
      sentto: 'Your giftcard for {0} was just sent to',
      depositSuccess: 'Thank you for your deposit!',
      newBalance: 'Your deposit balance is: ',
      couponPurchase: 'Thank you for your coupon purchase!',
      useFundsDeposit: 'Use Deposit',
      useFundsPurchase: 'Use Funds',
      makeAnotherDeposit: 'Make Another Deposit',
      makeAnotherPurchase: 'Make Another Purchase',
      giftCardValue: 'Gift Card Value',
      weveSentTheGiftCardTo: 'We’ve sent the gift card to',
      itShouldArriveShortly: 'It should arrive shortly.',
      startAnOrder: 'Start an Order',
      purchaseAnotherCard: 'Purchase Another Card',
      bonus: 'Bonus',
      depositSuccessful: 'Deposit successful',
      addedTo: 'Added to',
      depositValue: 'Deposit value',
      deposited: 'Deposited',
      creditAddedToMembership: 'Credit added to your balance — available now.',
    },

    deposit: {
      card1: {
        title: 'Add to Balance',
        subtitle: 'Choose a preset amount below.',
        bonusTip: 'Bonuses apply for higher deposits.',
        memberInformation: 'Account Information',
        memberInformationSubtitle: "This deposit will be added to the balance linked to this mobile number. We’ll also send a confirmation SMS.",
      },
      card2: {
        title: 'Deposit Bonus',
        subtitle: 'Deposit one of the amounts below for awesome bonuses!',
        bonusCoupons: 'Bonus Coupons',
        headers: [ 'Info', 'Deposit Amount', 'Bonus Cash', 'Bonus Points', 'Bonus Coupons', 'One time bonus' ],
        bonusInfo: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> with {1} in balance`,
        bonusInfoOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> with {1} or more in balance`,
        bonusInfoRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} bonus</span> with {1} - {2} in balance`,
        bonusInfoPoints: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> with {1} in balance`,
        bonusInfoPointsOrMore: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> with {1} or more in balance`,
        bonusInfoPointsRange: `<span style="color:var(--primary-color, #16a34a);font-weight:600;">{0} points</span> with {1} - {2} in balance`,
      },
      preset: 'Deposit Amount',
      backToDepositDetail: 'Back to Deposit Detail',
      backToHome: 'Back to Home',
      checkoutAndDeposit: 'Continue to Payment',
    },

    giftcard: {
      title: 'Gift Card Details',
      defaultMessage: 'Hope you like it!',
      chooseDesign: 'Choose the Perfect Gift Card',
      chooseDesignSub: 'Surprise someone special with a digital gift card, delivered instantly by text or email. Perfect for any celebration!',
      reChooseDesign: 'Want to try a different style? Click to browse more designs',
      sub1: 'Your giftcard can be sent via text or e-mail.',
      sub2: 'Please select a method.',
      card2: {
        title: 'GiftCard Bonus',
        subtitle: 'Purchase one of the Giftcards below for awesome bonuses!',
        headers: [ 'Info', 'Purchase Amount', 'Bonus Cash', 'Bonus Points', 'Bonus Coupons', 'One time bonus' ]
      },
      preset: 'Purchase Amount',
      backToAllGiftCards: 'Back to Gift Card selection',
      custom: 'Custom',
      currentPromotions: 'Current Promotions',
      message: 'Message(Optional)',
      giftCardDesign: 'Gift Card Design'
    },

    coupon: {
      title: 'Purchase Coupon(s)',

      addToCart: 'Add',
      remaining: 'Remaining',
      noneAvailable: 'No coupons are available for purchase at this time.'
    },

    migrate: {
      login: 'Please enter your mobile number to transfer points and balance',
      selectOfTwo: 'Please enter one of the two options',
      phoneHint: 'Please enter your mobile number',
      realFruitLogin: 'Please login to migrate your account',
      enterEmail: 'Please provide your account email',
      enterId: 'Please enter your giftcard number',
      externalId: 'Giftcard Number',
      giftCard: 'Giftcard Number',
      externalIdHint: 'The id provided by the service you wish to migrate',
      giftCardHint: 'Your gift card number',
      email: 'E-mail',
      emailHint: 'The E-mail provided by the service you wish to migrate',

      confirmDetails: 'Please confirm your details',
      name: 'Name:',
      externalID: 'Giftcard Number',
      pointsBalance: 'Points Balance',
      balance: 'Balance',
      tier: 'Tier',

      migrated: 'Your account was successfully migrated',
      migrateAgain: 'Migrate another giftcard'
    },

    errorReport: {
      main: 'Uh oh!',
      secondary: 'Something went wrong.',
      invalidWechat: 'Please scan this QR Code in Wechat app'
    },

    paymentDetails: {
      cardType: 'Credit',
      wechat: 'Wechat',
      cardNumber: 'Card Number',
      ready: 'Payment Details Ready',
      accepted: 'Payment Accepted',
      inProgress: 'Purchase request already in progress',
      cardDetailsError: 'Failed to read Payment Card Details',
      cardDetailsMissing: 'Please enter your card information',
      completePayment: 'Payment Detail',
      addTip: 'Add Tip',
      paymentFailed: 'Failed to complete payment, please check your info and try again',

      subtotal: 'Subtotal',
      tip: 'Tip',
      total: 'Total'
    },

    wechat: {
      error: 'An error has occurred please try again',
      mismatch: 'Card Does not match one on record'
    },

    userAcount: {
      accountInfo: 'Account Info',
      orderHistory: 'Order History',
      paymentMethods: 'Payment Methods',
    },

    forms: {
      billing: {
        phone: 'Billing Phone Number',
        sixDigitCode: '6 Digit Code',
        phoneHint: 'Enter your billing mobile number',
        phoneError: 'Please enter a phone number',
        name: 'Billing Name',
        nameHint: 'Name on card',
        email: 'Email me the receipt (optional)',
        emailHint: 'Enter your billing email',
        emailError: 'Please enter a valid email address',
        nameOnCard: 'Name on Card',
      },

      deposit: {
        phone: 'Mobile Number',
        phoneHint: 'Please enter the phone number you want to deposit',
        enterCustomAmount: 'Enter Custom Amount',
      },

      giftcard: {
        phone: 'Text Message',
        recipientMobilePhone: 'Recipient Mobile Number',
        phoneHint: 'The mobile number of who you want to receive the gift card',
        phoneError: 'Please enter a phone number',
        email: 'Email',
        emailHint: 'The e-mail of who you want to receive the gift card',
        recipientEmail: 'Recipient Email',
        emailError: 'Please enter an e-mail',
        name: 'Your Name',
        nameHint: 'This will appear in the recipients message',
        message: 'Message (Optional)',
        messageHint: 'This is a personalized message to be sent with your gift card',
        whoAreYouGiftingTo: 'Who are you gifting to?',
        personalNote: 'Personal note',
        termsAndConditions: 'Terms & Conditions',
        checkOutAndSendGift: 'Check Out & Send Gift',
        custom: 'Custom',
        enterCustomAmount: 'Enter Custom Amount',
        giftAmount: 'Gift amount',
        senderName:'Sender Name (Optional)',
        recipientName:'Recipient Name',
        recipientNameHint: 'The name of the person you are gifting to',
        recipientNameError: 'Please enter a recipient name',
        selectDeliveryMethod: 'Please select a delivery method',
        selectOrEnterAmount: 'Select or enter an amount between {0} - {1}',
        selectAnAmount: 'Select an amount',
        enterCustomDollarAmount: 'Enter custom amount',
      },

      coupon: {
        phone: 'Mobile Number',
        phoneHint: 'Enter your accounts phone number',
        couponsError: 'Please select a coupon'
      },

      emptyError: 'Please enter a name',
      amountPrompt: 'Enter Amount',
      cardPrompt: 'Please enter an amount',
      amountMax: 'Amount cannot exceed {0}',
      amountMin: 'Amount must be at least {0}',

      country: 'Billing Country',
      otherPostalCode: 'Postal Code',
      checkout: {
        selectCountry: 'Please select a country',
        enterPostalCode: 'Please enter your postal code',
        fillMissingFields: 'Please fill out missing field(s)'
      }
    },

    dialog: {
      recipient: 'Recipient',
      mobile: 'Mobile',
      amount: 'Amount',
      message: '{0} has sent you a gift card!'
    },
    presetRow: {
      title: 'Deposit Amount',
    },

    lottery: {
      loginTitle: 'Login to win prize!',
      noCoupons: 'No Coupons',
      title: 'Spin to win!',
      spin: 'SPIN',
      youWon: 'You Won!',
      useCoupon: 'Use Coupon',
      spinAgain: 'Spin Again',
      goShopping: 'Go Home',
      lossText: "You didn't win anything, better luck next time!"
    },

    login: {
      login: 'Login',
      phoneNumber: 'Phone Number',
      verifyCode: 'Verify Code',
    },
    hours: {
      twentyFourHours: 'Open 24 Hours',
      midNight: 'Midnight',
      mon: "Mon",
      tues: "Tue",
      wed: "Wed",
      thurs: "Thu",
      fri: "Fri",
      sat: "Sat",
      sun: "Sun",
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun"
    },

    // Unified cross-app nav row (DEV-10685/DEV-10688) -- same wording as OWA's
    // apps.* keys (src/locale/en.ts) and reservation's HEADER.* keys
    // (projects/reservation/src/assets/i18n/en.json), kept in a dedicated
    // namespace rather than common.giftcard/coupons/deposit above, which carry
    // different copy for the feature-select tiles ("Purchase <br> Gift Card").
    header: {
      location: 'Location',
      order: 'Order',
      reservation: 'Reservations',
      lineup: 'Waitlist',
      giftcard: 'Gift Cards',
      coupons: 'Purchase coupons',
      deposit: 'Add Funds',
      login: 'Login / Sign Up',
    },
  }
}
